<template>
    <div class="search" style="grid-template-columns: 1fr auto" :id="id">
        <div>
            <input type="hidden" :value="value" @input="input($event)">
            <div class="nj-label">{{ label }}</div>
            <div class="nj-search-box" :id="id + '-box'">
                <input type="text" class="nj-search-box-text" v-model="param" @keyup.enter="search()">
                <span class="nj-search-box-remove" @click="remove()" v-if="showRemove">
                    <i class="mdi-delete"></i>
                </span>
            </div>
            <div class="nj-result-list" v-if="showResult" :id="id + '-items'" :style="'width: ' + this.position.width" @blur="showResult = false">
                <div class="nj-flx align-center">
                    <div class="nj-result-list-item" v-for="item in items" :key="item[itemKey]" @click="select(item)">
                        <slot :item="item"></slot>
                        <i class="mdi mdi-arrow-right-bold"></i>
                    </div>
                    <span class="nj-search-box-remove" @click="close()">
                        <i class="mdi-block-helper"></i>
                    </span>
                </div>
            </div>
        </div>
        <Button label="Buscar" v-if="showButton" @click="search()"></Button>
    </div>
</template>
<script>
import Keyboard from "../../util/keyboard"
import { Button } from "../components"

export default {
    name: "SearchBox",
    components: {
        Button
    },
    props: {
        value: null,
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        itemKey: {
            type: String,
            required: true
        },
        itemLabel: {
            type: String,
            required: true
        },
        labelFunction: {
            type: Function,
            default: null
        },
        showButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            param: null,
            showResult: false,
            showRemove: false,
            position: {
                width: 0,
                top: 0,
                left: 0
            }
        }
    },
    watch: {
        items(value) {
            this.showResult = value.length != 0
        }
    },
    methods: {
        input(event) {
            this.$emit('input', event.target.value)
        },
        search() {
            this.$emit("search", this.param)
        },
        select(item) {
            this.$emit("select", item)
            this.showResult = false
            if (this.labelFunction != null) {
                this.param = this.labelFunction(item)
            } else {
                this.param = this.itemLabel ? item[this.itemLabel] : this.param
            }
            this.showRemove = this.param != undefined && this.param != null // para remover el item seleccionado
        },
        remove() {
            this.showRemove = false
            this.param = null
            this.$emit("input", null)
        },
        fix() {
            const input = document.getElementById(this.id + "-box")
            if (input) {
                const data = input.getBoundingClientRect()
                this.position.width = data.width + "px"
                if (this.isResult) {
                    const items = document.getElementById(this.id + "-items")
                    items.style.width = this.position.width
                }
            }
        },
        close() {
            this.showResult = false
        }
    },
    mounted() {
        this.fix()
        window.onresize = () => {
            this.fix()
        }

        Keyboard.escape(() => {
            this.close()
        }, this.id)
    }
}
</script>

<style scoped>
.search {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    grid: 0;
}

.nj-result-list {
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 400px;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: var(--radius);
    background-color: #fff;
    box-shadow: 0 4px 6px -4px #00000024;
    z-index: 1;
}

.nj-result-close {
    display: flex;
    justify-content: end;
    padding: 6px;
}

.nj-result-list-item {
    display: grid;
    gap: 4;
    grid-template-columns: 1fr auto;
    align-items: center;
    border: 1px solid #ccc;
    border-width: 0 0 1px 0;
    padding: 4px;
    flex: 1 1 auto;
}

.nj-result-list-item:hover {
    background-color: #ffb;
}

.nj-result-list-item>* {
    cursor: pointer;
    padding: 4px;
}

.nj-search-box {
    display: flex;
    align-items: center;
    width: 100%;
    outline: none;
    border: 1px solid #ccc;
    border-radius: var(--radius);

}

.nj-search-box-text {
    outline: none;
    border: 1px solid transparent;
    border-radius: var(--radius);
    line-height: 18px;
    padding: 3px 6px;
    color: #666;
    font-size: var(--font-size);
    flex-shrink: 1;
    flex-grow: 1;
}

.nj-search-box-remove {
    cursor: pointer;
    flex-shrink: 0;
    flex-grow: 0;

}

.nj-search-box-remove>i {
    cursor: inherit;
    padding: 0 4px;
}
</style>